export class PreferenceCpvTableau {
  id: number;
  titre: string;
  compteur: number;
  values: string[];
  dateCreation : Date;
}
